module.exports = __webpack_public_path__ + "img/rang6.d3b5f88d.png";